export default "__VITE_ASSET__BnQqGuj2__"